import Vue from 'vue';

Vue.filter('percentage', (value) => {
  if (!value) {
    return '';
  }

  return `${(value * 100).toFixed(2)}%`;
});
